import React from "react";

class SpinnerComponent extends React.Component {
  state = {
    loading: true,
  };
  render() {
    return (
      <div className="spinner_overlay">
        <img
          className="spinner"
          src={require("assets/chilirojo/images/logos/logo.webp")}
        />
      </div>
    );
  }
}

export default SpinnerComponent;
